export const validateDateString = (value: Date, originalValue: string) => {
  const startDate = new Date(originalValue);
  if (!(startDate instanceof Date && !isNaN(startDate.getTime()))) {
    return false;
  }
  return startDate;
}
